import { render, staticRenderFns } from "./ProjekterfassungModal.vue?vue&type=template&id=767811ed"
import script from "./ProjekterfassungModal.vue?vue&type=script&lang=js"
export * from "./ProjekterfassungModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports